module.exports = __webpack_public_path__ + "img/claimant.f3b78691.png";